import React from 'react';
import MigrationList from './MigrationList';
export default function MigrationUsers() {
    return <MigrationList url={'user'} keyLabel="name" />
};